import type { IncomeProtectionDaSettingCreationType } from './types';

export const INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED = {
  benefit_period_num_of_days: 'benefit_period_num_of_days',
  waiting_period_num_of_days: 'waiting_period_num_of_days',
  start_date: 'start_date',
  payment_frequency_num_of_days: 'payment_frequency_num_of_days',
  average_weekly_income: 'average_weekly_income',
  weekly_payment_limit: 'weekly_payment_limit',
  weekly_income_percentage: 'weekly_income_percentage',
  claimant_weekly_limit: 'claimant_weekly_limit',
  payee_contact_id: 'payee_contact_id',
  exposure_id: 'exposure_id',
} as const satisfies Record<keyof IncomeProtectionDaSettingCreationType, keyof IncomeProtectionDaSettingCreationType>;

export const REQUIRED_INCOME_PROTECTION_SETTING_KEYS = [
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.benefit_period_num_of_days,
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.waiting_period_num_of_days,
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.start_date,
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.payment_frequency_num_of_days,
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.average_weekly_income,
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.weekly_payment_limit,
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.weekly_income_percentage,
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.claimant_weekly_limit,
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.payee_contact_id,
  INCOME_PROTECTION_SETTING_CREATION_KEYS_MAPPED.exposure_id,
] as const;
